import { useEffect, useState } from "react";
import api from "../../../lib/api";
import { Card } from "../../../components/ui/card";
import { Table, RangeBar, useRange, TL, fmt, chLabel, Verdict } from "./ui";

export default function Channels() {
  const [r, setR] = useRange(90); const [d, setD] = useState(null);
  useEffect(() => { api.get("/mkt/channels", { params: { date_from: r.from, date_to: r.to } }).then((x) => setD(x.data)); }, [r]);
  if (!d) return null;
  return (
    <div className="space-y-4" data-testid="mk-channels">
      <RangeBar r={r} setR={setR} />
      {d.tips.length > 0 && <Card className="p-4 shadow-none border-amber-200 bg-amber-50/50 space-y-1" data-testid="mk-tips"><div className="font-semibold text-sm">Öneriler</div>{d.tips.map((t, i) => <div key={i} className="text-sm">• {t}</div>)}</Card>}
      <Card className="p-4 shadow-none border-slate-200">
        <Table testid="mk-ch-table" rows={d.rows} cols={[
          { h: "Kanal", f: (x) => <b>{chLabel(x.channel)}</b> }, { h: "Ziyaret", k: "sessions", right: true }, { h: "Form+Arama", k: "contacts", right: true }, { h: "İş", k: "jobs", right: true },
          { h: "Biten", k: "done", right: true }, { h: "Ciro", right: true, f: (x) => TL(x.revenue) }, { h: "Şirket payı", right: true, f: (x) => TL(x.net_est) },
          { h: "Harcama", right: true, f: (x) => (x.cost ? TL(x.cost) : "—") }, { h: "İş başı maliyet", right: true, f: (x) => TL(x.cpa) }, { h: "ROAS", right: true, f: (x) => (x.roas ? `${x.roas}×` : "—") },
          { h: "Kâr", right: true, f: (x) => (x.cost ? TL(x.profit) : "—") }, { h: "", f: (x) => <Verdict v={x.verdict} /> },
          { h: "Yeni müşteri", k: "new_customers", right: true }, { h: "Tekrar %", right: true, f: (x) => `%${fmt(x.repeat_pct)}` }, { h: "Yaşam değeri", right: true, f: (x) => TL(x.ltv) }, { h: "YD / maliyet", right: true, f: (x) => (x.ltv_cac ? `${x.ltv_cac}×` : "—") },
        ]} />
        <p className="text-[11px] text-slate-500 mt-3">{d.note} Şirket payı = iş tutarı × firma yüzdesi (parça maliyeti kayıtlı değil). "Kanal belirtilmemiş" satırı büyükse iş açarken kaynak kanalı doldurun veya aramaları Aramalar sekmesinden kaydedin.</p>
      </Card>
    </div>
  );
}
